import React from "react";
import ContentTabs from "../modules/ContentTabs";
import { useSelector } from "react-redux";
import ModuleHeader from "../modules/ModuleHeader";

const ModulePageLayout = ({ children, module, topic, part }) => {
  const topicTitle = (topic.data && topic.data.title) || topic.title;

  const parts =
    useSelector((state) =>
      topic.contentKey ? state.parts[topic.contentKey] : []
    ) || [];

  return (
    <div className="px-3 lg:px-0">
      <ModuleHeader
        bgColor={module && module.data ? module.data.accentColor : ""}
        number={
          module && module.data && module.data.order
            ? module.data.order - 1
            : undefined
        }
        title={(module && module.data.title) || module.title}
      />

      <div className="lg:hidden pt-4">{topicTitle}</div>

      <div className="flex justify-between py-tabs">
        <div className="hidden lg:block lg:w-1/3 pt-4">{topicTitle}</div>
        <div className="w-full lg:w-2/3">
          <ContentTabs
            partIndex={part}
            url={`/app/${module.contentKey}/${topic.contentKey}`}
            title1={
              parts[1] && parts[1].data && parts[1].data.title
                ? parts[1].data.title
                : parts[1] && parts[1].title
            }
            title2={
              parts[2] && parts[2].data && parts[2].data.title
                ? parts[2].data.title
                : parts[2] && parts[2].title
            }
            title3={
              parts[3] && parts[3].data && parts[3].data.title
                ? parts[3].data.title
                : parts[3] && parts[3].title
            }
            color={module.data.accentColor}
            topic={topic}
          />
        </div>
      </div>

      <div className="bg-white shadow rounded pt-12 px-8 lg:pt-12 lg:px-24">
        {children}
      </div>
    </div>
  );
};

export default ModulePageLayout;
